export const blackFridayDeadline = new Date('2024-11-30T23:59:59.999'); //завершение акции Черная Пятница 2024
